import axios from 'axios'
import { useUserStore } from '@/stores/user'

let isLoggingOut = false

// Default timeout for requests (120s) - can be overridden per-request
axios.defaults.timeout = 120000

// Retry configuration for timeout errors
const RETRY_CONFIG = {
  maxRetries: 2,
  retryDelay: 500
}

// Check if error is retryable (timeout or network error)
function isRetryableError(error) {
  // 504 Gateway Timeout from server
  if (error.response?.status === 504) {
    return true
  }

  // Network errors (no response) - includes browser timeouts, connection refused, etc.
  if (!error.response && (error.code === 'ECONNABORTED' || error.message?.includes('timeout') || error.message?.includes('Network Error'))) {
    return true
  }

  return false
}

axios.interceptors.response.use(
  response => response,
  async error => {
    const config = error.config

    // Handle 401 Unauthorized responses
    if (error.response?.status === 401 && !isLoggingOut) {
      isLoggingOut = true
      const userStore = useUserStore()
      await userStore.logout("Your session has expired. Please log in again.", true)
      isLoggingOut = false
      return Promise.reject(error)
    }

    // Retry logic for timeout and network errors
    if (isRetryableError(error) && config) {
      config.__retryCount = config.__retryCount || 0

      if (config.__retryCount < RETRY_CONFIG.maxRetries) {
        config.__retryCount++

        await new Promise(resolve => setTimeout(resolve, RETRY_CONFIG.retryDelay))

        return axios(config)
      }
    }

    return Promise.reject(error)
  }
)

export default axios
